import React from "react";
import { Paper, Typography, Box } from "@mui/material";

export default function StatCard({ title, value, subtitle }) {
    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                borderRadius: "10px",
                border: "1px solid #ECEFF5",
                
                transition: "0.2s",
                "&:hover": {
                    boxShadow: "0 8px 24px rgba(0,0,0,.08)",
                },
            }}
        >
            <Typography
                sx={{
                    fontSize: 15,
                    fontWeight:400 ,
                    color: "#64748B",
                    mb: 0.5,
                }}
            >
                {title}
            </Typography>

            <Typography
                sx={{
                    fontSize: 36,
                    fontWeight: 700,
                    color: "#111827",
                }}
            >
                {value}
            </Typography>

            <Typography
                sx={{
                    fontSize: 13,
                    color: "#6B7280",
                    mt: 1,
                }}
            >
                {subtitle}
            </Typography>
        </Paper>
    );
}